var _rect, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcEtherium = function SvgCcEtherium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.435,
    cy: 11.935,
    r: 7.935,
    fill: "#6481E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CCF5",
    fillRule: "evenodd",
    d: "M17.528 6.352v8.01l3.56-2.104-3.56-5.906Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m13.968 12.258 3.56 2.104v-8.01l-3.56 5.906Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8299EC",
    fillRule: "evenodd",
    d: "m17.528 10.64-3.56 1.618 3.56 2.104 3.56-2.104-3.56-1.618Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CCF5",
    fillRule: "evenodd",
    d: "m17.528 10.64-3.56 1.618 3.56 2.104V10.64ZM17.528 15.036v2.913l3.562-5.016-3.562 2.103Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m13.969 12.933 3.559 5.016v-2.913l-3.56-2.103Z",
    clipRule: "evenodd"
  })));
};
export default SvgCcEtherium;